import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {SearchPref} from '../constants';

export const aiSearchEnabled = () =>
	getPreference(SearchPref.AI_SEARCH_ENABLED, true);
